import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { EnterpriseUserUsage } from '@/api/usage'
import type { RootState } from '@/store'

interface UsageState {
  users: EnterpriseUserUsage[]
  isLoaded: boolean
  lastFetchedAt: number | null
}

const initialState: UsageState = {
  users: [],
  isLoaded: false,
  lastFetchedAt: null,
}

export const usageSlice = createSlice({
  name: 'usage',
  initialState,
  reducers: {
    setUsageData: (
      state,
      action: PayloadAction<{
        users: EnterpriseUserUsage[]
      }>
    ) => {
      state.users = action.payload.users
      state.isLoaded = true
      state.lastFetchedAt = Date.now()
    },
    clearUsageData: (state) => {
      state.users = []
      state.isLoaded = false
      state.lastFetchedAt = null
    },
  },
})

export const { setUsageData, clearUsageData } = usageSlice.actions

// Selectors
export const selectUsageUsers = (state: RootState) => state.usage.users
export const selectUsageIsLoaded = (state: RootState) => state.usage.isLoaded
export const selectUsageLastFetchedAt = (state: RootState) => state.usage.lastFetchedAt

export default usageSlice.reducer
